/**
 * Addon-tier modules bundled with each plan (mirrors backend PROJECT_PLAN_REGISTRY).
 */
export const PLAN_ADDON_MODULES = {
  starter: [],
  pro: ['trends', 'telegram', 'svg_hmi', 'project_tags', 'project_alarm_rules'],
  enterprise: [
    'trends',
    'telegram',
    'svg_hmi',
    'project_tags',
    'project_alarm_rules',
    'commands_advanced',
    'maps',
    'debug_tools',
  ],
};

export function addonModulesForPlan(planCode) {
  return [...(PLAN_ADDON_MODULES[planCode] ?? [])];
}

export function isPlanBundledAddon(planCode, moduleCode) {
  return (PLAN_ADDON_MODULES[planCode] ?? []).includes(moduleCode);
}
